/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "RejectNFT",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "TokenReceived",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506101fb806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063150b7a0214610030575b600080fd5b61004361003e3660046100d6565b610060565b6040516001600160e01b0319909116815260200160405180910390f35b60007f5343d39c46825e39cfee854256354ed1b3837af99997a3242ae29e831889773c8686868686604051610099959493929190610171565b60405180910390a160405163a280619b60e01b815260040160405180910390fd5b80356001600160a01b03811681146100d157600080fd5b919050565b6000806000806000608086880312156100ee57600080fd5b6100f7866100ba565b9450610105602087016100ba565b935060408601359250606086013567ffffffffffffffff8082111561012957600080fd5b818801915088601f83011261013d57600080fd5b81358181111561014c57600080fd5b89602082850101111561015e57600080fd5b9699959850939650602001949392505050565b6001600160a01b038681168252851660208201526040810184905260806060820181905281018290526000828460a0840137600060a0848401015260a0601f19601f8501168301019050969550505050505056fea2646970667358221220573b9680ae3ef761e1a18a3044c773df32f65c3bc6d9f4aba77b6985644fab8164736f6c63430008180033";
const isSuperArgs = (xs) => xs.length > 1;
export class ExampleERC721ReceiverRevert__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ExampleERC721ReceiverRevert__factory.bytecode = _bytecode;
ExampleERC721ReceiverRevert__factory.abi = _abi;
//# sourceMappingURL=ExampleERC721ReceiverRevert__factory.js.map